module.exports = __webpack_public_path__ + "img/whatsnew-selectioncolorfill_en.6c691c9.jpg";